import { useEffect, useRef } from 'react';

/**
 * Allows for conditionally locking scrolling.
 * When true is passed in, the user cannot scroll.
 */
const useScrollLock = (lock = true) => {
  const original = useRef(getComputedStyle(document.body).overflow);

  useEffect(() => {
    if (lock) {
      original.current = getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = original.current;
    }

    return () => {
      document.body.style.overflow = original.current;
    };
  }, [lock]);
};

export default useScrollLock;
